import { render, staticRenderFns } from "./agreeToReturn.vue?vue&type=template&id=98da49fa&scoped=true"
import script from "./agreeToReturn.vue?vue&type=script&lang=js"
export * from "./agreeToReturn.vue?vue&type=script&lang=js"
import style0 from "./agreeToReturn.vue?vue&type=style&index=0&id=98da49fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98da49fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98da49fa')) {
      api.createRecord('98da49fa', component.options)
    } else {
      api.reload('98da49fa', component.options)
    }
    module.hot.accept("./agreeToReturn.vue?vue&type=template&id=98da49fa&scoped=true", function () {
      api.rerender('98da49fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/components/agreeToReturn.vue"
export default component.exports